import React from "react";
import "./Pages.css";
import chat from "../../assets/chat.png";

const Anzeige = () => {
  return (
    <div className="anzeige">
      <img width={300} src={chat} alt="Anzeige" />
      <p><div className="notice-box" style={{ color: "red" }}>
        <h1>Praxis geschlossen!!!!</h1><pre/>

        <p style={{ color: "red" }}>
          Aufgrund von Personalmangels bleibt meine Praxis <strong> am Montag, den 30.03.2026 ab 13 Uhr </strong><br />
          geschlossen.
        </p>

        <p style={{ color: "red" }}>
          In dringenden Notfällen wenden Sie sich bitte an das nächstgelegene Krankenhaus!
        </p><pre/>
        </div>
      
        
        Wir sind eine Facharztpraxis, da kann es schon durchaus zu etwas längeren<pre/>
        Wartezeiten kommen. Dafür bitten wir um Verständnis.<pre/>
        <pre/>
        Die Untersuchung bei Neupatienten ist immer etwas aufwändiger. Bitte planen
        Sie genügend Zeit ein.<pre/>
        <pre/>
        Wir haben mehrere Untersuchungs-/Behandlungsräume, deswegen kann es
        auch durchaus sein, dass ein Patient, der nach Ihnen kam, vor Ihnen aufgerufen
        wird.<pre/>
        <pre/>
        Viele Patienten kommen z.B. nur zur Blutabnahme, Katheterwechsel usw. und
        müssen an diesem Tag nicht zum Arzt.<pre/>
        Das sind Untersuchungen, die von den Fachangestellten durchgeführt
        werden.<pre/>
        <pre/>
        An manchen Tagen haben wir auch Notfälle. Dies sind Patienten mit z.B.
        Koliken und unter Schmerzen können diese Patienten nicht warten und
        brauchen zeitnah eine Versorgung.<pre/>
        <pre/>
        Wir bitten um Ihr Verständnis.<pre/>
        Ihr URO-Praxis Team<pre /><pre />
      </p>
    </div>
  );
};

export default Anzeige;
